module.exports = "<variable-plan-page></variable-plan-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/variable.html
// module id = 2101
// module chunks = 0